import { makeAxiosClient } from 'lib/api/makeAxiosClient'
import { domains } from 'config/env'
import { formatError } from 'utils/formatError'
import { isFlagOn, PUBLISHED_CONTENT_FLAG } from 'utils/featureFlags'
import { actions } from './reducer'
import { createCurriculumNavigationStateKey } from './selectors'

// The page loader waits on this request, so cap it: past this the page renders
// without the subnav and the next route change retries.
export const NAVIGATION_REQUEST_TIMEOUT_MS = 5000

const getClient = () => makeAxiosClient(domains.CURRICULUM_SERVICE)

/**
 * Fetch the program subnav tree from the curriculum service GET /v1/navigation
 * endpoint. The response covers the whole program, so it is cached per
 * content group + site rather than per route.
 */
const fetchCurriculumNavigation = ({ contentGroupCode, siteId }) => {
  return async dispatch => {
    const navigationStateKey = createCurriculumNavigationStateKey(
      contentGroupCode,
      siteId,
    )
    dispatch(actions.fetchingNavigation({ navigationStateKey }))

    try {
      const client = getClient()
      const response = await client.get('/v1/navigation', {
        params: {
          contentGroupCode,
          siteId,
          ...(!isFlagOn([PUBLISHED_CONTENT_FLAG]) ? { draftMode: 'true' } : {}),
        },
        timeout: NAVIGATION_REQUEST_TIMEOUT_MS,
      })
      dispatch(
        actions.fetchNavigationSuccess({
          navigationStateKey,
          data: response.data,
        }),
      )
    } catch (error) {
      dispatch(
        actions.fetchNavigationError({
          navigationStateKey,
          error: formatError(error),
        }),
      )
    }
  }
}

export default {
  fetchCurriculumNavigation,
}
